/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2015, Bulb Inc.  For more information, please email contact@hellobulb.com.
*/
'use strict';

angular.module('bulbApp.filtersModule')

/**
 * An Angular filter which escapes text so it can be safely displayed.
 */
.filter('escapeHtml', function() {
  // These entities are from OWASP's recommendations:
  // https://www.owasp.org/index.php/XSS_%28Cross_Site_Scripting%29_Prevention_Cheat_Sheet
  var entityConversionMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    '\'': '&#39;',
    '/': '&#x2F;'
  };

  function escapeHtml(str) {
    return String(str).replace(/[&<>"'\/]/g, function (s) {
      return entityConversionMap[s];
    });
  }

  return escapeHtml;
});
